const Error404 = () => {
    return(
        <h1>
            Página não encontrada.
        </h1>
    );
}

export default Error404;